module.exports = __webpack_public_path__ + "img/07.6d4a25e1.jpg";